import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';

export const startAudioInputContext = createAction(`${NAME}/startAudioInputContext`);

export const promptForMicrophoneAccess = createAction(`${NAME}/promptForMicrophoneAccess`);
